export class SameHeight {
    init()
    {
        equalizeHeights();

        function equalizeHeights() {
            var maxHeight = 0;

            $(".articles-list__content").each(function(){
                if ($(this).height() > maxHeight) { maxHeight = $(this).height() + 25; }
            });

            $(".articles-list__content").height(maxHeight);
        }

        $(window).resize(function(){
            equalizeHeights();

            });

    }
}
